import React from 'react';
import PropTypes from 'prop-types';
import FooterType01 from '../SiteSubGenerator/FooterType01';
import FooterType02 from '../SiteSubGenerator/FooterType02';

const FOOTER_COMPONENTS = {
  'siteSub.footer-01': FooterType01,
  'siteSub.footer-02': FooterType02,
};

const GlobalFooter = ({ site, footerType }) => {
  if (!site || !footerType) return null;

  const FooterComponent = FOOTER_COMPONENTS[footerType];
  if (!FooterComponent) return null;

  // site prop 전달 (SNS 링크용)
  return <FooterComponent site={site} />;
};

GlobalFooter.propTypes = {
  site: PropTypes.object,
  footerType: PropTypes.string,
};

GlobalFooter.defaultProps = {
  site: null,
  footerType: 'siteSub.footer-01',
};

export default GlobalFooter;
